import { RouteRecordRaw } from 'vue-router'
import { usersModuleRoutes } from '@/modules/users'
import { invitationModuleRoutes } from '@/modules/invitations'
import { dashboardModuleRoutes } from '@/modules/dashboard'
import { calendarModuleRoutes } from '@/modules/calendar'
import { businessIntelligenceModuleRoutes } from '@/modules/business-intelligence'

const DashboardLayout = () =>
  import(
    /* webpackChunkName: "dashboard-layout" */ '@/core/layouts/DashboardLayout.vue'
  )

export const dashboardRoutes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: { name: 'dashboard' },
    component: DashboardLayout,
    meta: {
      auth: true,
    },
    children: [
      ...dashboardModuleRoutes,
      ...usersModuleRoutes,
      ...invitationModuleRoutes,
      ...calendarModuleRoutes,
      ...businessIntelligenceModuleRoutes,
    ],
  },
]
